import type { FilterKeys } from "@dresscode-frontend/utility-types";
import type { ColumnDef } from "@tanstack/table-core";

import AssignmentRuleCell from "@/components/DataTable/Cells/AssignmentRuleCell";
import { DataTableColumnHeader } from "@/components/DataTable/Columns/DataTableColumnHeader";
import type { HelperOptions } from "@/components/DataTable/types";

import type { RuleMatching } from "../types";

/** AppUserがアサインメントルールに対して合致するAppUserの判定を表現するカラム */
export function RuleBadgeColumn<TData>(
  id: FilterKeys<TData, RuleMatching> & string,
  helperOptions: HelperOptions = {},
): ColumnDef<TData> {
  const { minWidth = "180px" } = helperOptions;

  return {
    accessorKey: id,
    enablePinning: true,
    enableSorting: helperOptions.sortable,
    meta: { i18nKey: helperOptions.i18nKey, thStyle: { minWidth } },
    header: DataTableColumnHeader,
    cell({ getValue }) {
      const ruleMatching = getValue() as RuleMatching;
      return <AssignmentRuleCell rule={ruleMatching} />;
    },
  } satisfies ColumnDef<TData>;
}
